import { IconoBuscar } from '../iconos';
import './listado.css';

/**
 * La caja de búsqueda de la barra del listado: 280 × 40, lupa a la izquierda.
 *
 * Es controlada y avisa en cada tecla. Esperar a que la persona deje de escribir
 * antes de consultar lo hace la pantalla con `useBusquedaDiferida`, que recibe
 * cuánto esperar: la pantalla sabe cuánto le cuesta cada consulta.
 */
export function Buscador({
  valor,
  onCambiar,
  placeholder,
  etiqueta,
}: {
  valor: string;
  onCambiar: (valor: string) => void;
  /** «Buscar por código o por nombre». */
  placeholder: string;
  /** Lo que lee el lector de pantalla. Por omisión, el mismo placeholder. */
  etiqueta?: string;
}) {
  return (
    <label className="ui-buscador">
      <IconoBuscar />
      <input
        type="search"
        value={valor}
        placeholder={placeholder}
        aria-label={etiqueta ?? placeholder}
        onChange={(e) => onCambiar(e.target.value)}
      />
    </label>
  );
}
